import React from "react";
import { showModal } from "../../../../../../lib/react-redux-modal-provider";

const StockPageTagsButton = ({ stockId, ticker }) => {
  return (
    <button
      className={
        "flex align-center bg-gray-7 border-none rounded-1 hover:bg-gray-6 focus:bg-gray-6 p-3 rounded-full text-base text-blue"
      }
      onClick={() => {
        showModal("StockTagsListModal", { stockId, ticker });
      }}
    >
      <i className="fas fa-tag" />
    </button>
  );
};

export default StockPageTagsButton;
